import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../../actions/authActions';
import FlyInRightPanel from '../../../components/FlyInRightPanel'
import isEmpty, {trans} from "../../../utils/helpers";
import Profile from "../../Home/Profile";
import Notifications from "../../Notifications/index";
import {
	selectLinkedAccounts,
	selectLinkedAccountsError,
	selectLinkedAccountsLoading,
	selectIsActive,
	selectLinkedUsers,
	selectAuth
} from '../../../selectors'
import linkedAccount from "../../LinkedAccounts/LinkedAccount";
import {toggleIsActive} from "../../../actions/linkedAccountsInfoActions";
import LinkedAccountTable from "../../../components/LinkedAccountTable";


const PANEL = {
    NONE: 0,
    INVOICES: 1,
    MANAGE_PLANS: 2,
    PAYMENT: 3,
    AUTOPAY: 4,
    PAPERLESS: 5,
    ORDERS: 6,
    PAYMENTS: 7,
    MANAGE_PAYMENTS: 8,
    ADD_EDIT_PAYMENT_METHODS: 9,
    ONE_TIME_PAYMENT: 10,
	LINKED_ACCOUNTS: 11,
}

export class UserNavbar extends Component {
	static propTypes = {
		accountInfo: PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.linkedAccountTableRef = React.createRef();
		this.state = {
			companyName:'',
			dropdown: '',
			isOpen: false,
			isMobileMenuOpen: false,
			isNotificationsOpen: false,
			isChangePasswordMenuOpen: false,
			isLinkAccountOpen: false,
			activePanel: PANEL.NONE,
			visiblePanel: PANEL.NONE,
			resetFormOnClose: false,
			preventPanelClosing: false,
			resetForm: false,
			resetFormMess: null
		};
	}

	componentDidMount(){


		(async() => {
			const companyName= await trans('en-us', 'companyName');

			this.setState({companyName})
		})()


	}
	onFocuschangeActiveDropDown = (e, name) => {
		this.setState((prevProps) => ({
			dropdown: name,
			isOpen: !prevProps.isOpen
		}));
	};

	onBlurchangeActiveDropDown = (e, name) => {
		this.setState((prevProps) => ({
			dropdown: '',
			isOpen: false
		}));
	};

	handleResetForm = () => {
		this.setState(prevState => ({ resetForm: !prevState.resetForm }));
	}

	handleShowHideMenuDropdown = () => {
		this.setState((prevState) => ({
			isMobileMenuOpen: !prevState.isMobileMenuOpen
		}))
	};

	handleShowHideChangePassword = (resetForm) => {
		if(resetForm) resetForm()
		this.setState((prevState) => ({
			isChangePasswordMenuOpen: !prevState.isChangePasswordMenuOpen
		}))
	}

	handleShowHideNotifications = () => {
		this.setState((prevState) => ({
			isNotificationsOpen: !prevState.isNotificationsOpen
		}));

	};

	handleShowLinkedAccounts = () => {
		this.setState((prevState) => ({
			isLinkAccountOpen: !prevState.isLinkAccountOpen
		}));
		this.handleResetForm();
		if (this.state.resetFormMess) {
			this.state.resetFormMess();
		}
	};

	logout = () => {
		this.props.logout(this.props.history);
	}

	togglePanel = async (panel, hideTimeoutMs, getInitialSate, onHideCallback) => {


		if (this.state.activePanel === panel) {
			this.hidePanel(hideTimeoutMs, onHideCallback);
		} else {
			this.showPanel(panel, getInitialSate);
		}

		this.setState({resetFormOnClose: true}, () => {
			this.setState({resetFormOnClose: false});
		})
	}

	handleFormikInteraction = (resetForm) => {
		this.setState({ resetFormMess: resetForm });
	};

	resetLinkedAccountMessages = () => {
		if (this.linkedAccountTableRef.current) {
			this.linkedAccountTableRef.current.resetMessages();
		}
	}

	render() {
		const { dropdown, isOpen, isMobileMenuOpen, isNotificationsOpen, isChangePasswordMenuOpen, isActive, isLinkAccountOpen, preventPanelClosing, visiblePanel, resetFormOnClose, activePanel } = this.state;
		const { accountInfo, toggleIsActive, currUser } = this.props;
		const menuContent = (window.navbarLinks && window.navbarLinks.map(item => (
			<li className="nav-item" key={item.name}>
				<a className="nav-link" href={item.link} target={item.newWindow ? '_blank' : '_self'}>
					<i className={'fas fa-fw' + (item.newWindow ? ' fa-external-link-alt' : '')}/>
					{item.name}
				</a>
			</li>
		)));



		return (
			<>

				<FlyInRightPanel title="Menu" onClose={this.handleShowHideMenuDropdown} isVissible={isMobileMenuOpen}>
					<ul className="navbar-nav">
						{menuContent}
					</ul>
				</FlyInRightPanel>

				<FlyInRightPanel title="Profile" onClose={this.handleShowHideChangePassword} isVissible={isChangePasswordMenuOpen}>
					<ul className="navbar-nav">
						<Profile handleShowHideChangePassword={this.handleShowHideChangePassword} />
					</ul>
				</FlyInRightPanel>

				<FlyInRightPanel title="Communication Preferences" onClose={this.handleShowHideNotifications} isVissible={isNotificationsOpen}>
					<ul className='navbar-nav'>
						<Notifications />
					</ul>
				</FlyInRightPanel>

				<FlyInRightPanel
				       title="Linked Accounts & Users"
				      isVissible={isLinkAccountOpen}
				     onClose={() => {
						 this.handleShowLinkedAccounts()
						 this.resetLinkedAccountMessages();

				        //    this.togglePanel(PANEL.LINK_ACCOUNT);  - Jorge 6-7-2024
				        //     this.setState({ resetFormOnClose: true }, () => { - Jorge 6-7-2024
				        //        this.setState({ resetFormOnClose: false });  - Jorge 6-7-2024
				        //     })
				        }}
				    >
				      <LinkedAccountTable ref={this.linkedAccountTableRef} systemUserId={currUser.userid}  resetForm={this.state.resetForm} handleResetForm={this.handleResetForm} onFormikInteraction={this.handleFormikInteraction}/>
				    </FlyInRightPanel>

				<header className="cp-header cp-header-user">
					<nav className="navbar navbar-light cp-navbar cp-navbar-user">
						<div className="container">

							{(window.logoLink === '' ? (
								<span className="navbar-left navbar-img">
									<img src={`${process.env.PUBLIC_URL}/themes/active/img/app-banner.svg`} />
								</span>
							) : (
								<a className="navbar-left navbar-img" href={window.logoLink} target="_blank" rel="noopener noreferrer">
									<img src={`${process.env.PUBLIC_URL}/themes/active/img/app-banner.svg`} />
								</a>
							))}

							<span className="navbar-brand">
                            	{window.translations['en-us'].companyName !== '' &&this.state.companyName}
							</span>

							<div className="navbar-right">

								<ul className="navbar-nav">
									{menuContent}
								</ul>

								<div
									className="dropdown"
									onClick={(e) => this.onFocuschangeActiveDropDown(e, 'user')}
									onBlur={(e) => this.onBlurchangeActiveDropDown(e, 'user')}
								>

									<a
										className="nav-link nav-link-user dropdown-toggle"
										id="navbarDropdownMenuLink"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i className="far fa-user" />
										<span className="nav-link-user-username">
											{accountInfo && accountInfo.primaryContact && !isEmpty(accountInfo.primaryContact.company)
												? accountInfo.primaryContact.company
												: accountInfo.primaryContact.firstName + ' ' + accountInfo.primaryContact.lastName
											}
										</span>
									</a>

									<div
										className={'dropdown-menu dropdown-menu-right' + (dropdown === 'user' && isOpen ? ' show' : '')}
										aria-labelledby="navbarDropdownMenuLink"
									>
										<h6 className="dropdown-header">
											{accountInfo && accountInfo.primaryContact && accountInfo.primaryContact.firstName}{' '}
											{accountInfo && accountInfo.primaryContact && accountInfo.primaryContact.lastName}
										</h6>
										<div className="dropdown-divider"></div>
										<button onClick={() => this.setState({isChangePasswordMenuOpen: true})}
												className="dropdown-item">
											Profile
										</button>
										<button onClick={() => this.setState({isNotificationsOpen: true})}
												className="dropdown-item">
											Communication Preferences
										</button>
										<button className="dropdown-item" onClick={ () => this.setState({isLinkAccountOpen: true})}>
											Link Account
										</button>
										{this.props.linkedAccounts && this.props.linkedAccounts.linkedAccountList && this.props.linkedAccounts.linkedAccountList.length > 0 && isActive === false && (<button className="dropdown-item" onClick={() => {
											toggleIsActive(true)
										}}>
											Linked Accounts & Users
										</button>)}

										<button onClick={this.logout} className="dropdown-item">
											Sign Out
										</button>
									</div>
								</div>

								{(window.navbarLinks && (
									<button
										className='navbar-toggler'
										type="button"
										data-toggle="collapse"
										data-target="#navbarNavDropdown"
										aria-controls="navbarNavDropdown"
										aria-expanded={isMobileMenuOpen ? 'true' : 'false'}
										aria-label="Toggle navigation"
										onClick={this.handleShowHideMenuDropdown}
									>
										<span className="navbar-toggler-icon"/>
									</button>
								))}

							</div>

						</div>
					</nav>
				</header>


		</>
		);
	}
}

const mapStateToProps = (state) => {
	const linkedAccounts = selectLinkedAccounts(state);
	const loading = selectLinkedAccountsLoading(state);
	const error = selectLinkedAccountsError(state);
	const isActive = selectIsActive(state);
	const currUser = selectAuth(state);

	return {
		linkedAccounts,
		loading,
		error,
		isActive,
		currUser
	}
};

const mapDispatchToProps = {
	logout,
	toggleIsActive
};

export default connect(mapStateToProps, mapDispatchToProps)(UserNavbar);
